import React from 'react'

const Music = () => {
  return (
    <div className="music-page-container">
      <h1>producer.</h1>
    </div>
  )
}
export default Music